import { render, staticRenderFns } from "./AgeSlider.vue?vue&type=template&id=c03b6c54&scoped=true&"
import script from "./AgeSlider.vue?vue&type=script&lang=js&"
export * from "./AgeSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03b6c54",
  null
  
)

export default component.exports